import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./styles.module.css";
import { ProgressIndicator } from "@asosteam/asos-web-component-library-progress-indicator";

export default function WithLoader({
  children,
  padding = 15,
  loading = false,
  style = {},
}) {
  const classes = classNames({
    [`${styles.hidden}`]: loading,
  });

  return (
    <>
      {loading && (
        <div className={styles.loader} style={{ padding, ...style }}>
          <ProgressIndicator size="small" progressMessage="loading" />
        </div>
      )}
      <div className={classes}>{children}</div>
    </>
  );
}

WithLoader.propTypes = {
  children: PropTypes.node.isRequired,
  padding: PropTypes.number,
  loading: PropTypes.bool,
  style: PropTypes.object,
};
